import React from 'react';
import { ListItemText, Menu, MenuItem, Box, Typography } from '@mui/material';
import type { ContentStatus } from './StatusPill';

const OPTIONS: Array<{ value: ContentStatus; label: string; description: string; dot: string }> = [
  { value: 'draft',    label: 'Draft',    description: 'Visible to you and Team Admins', dot: '#94A3B8' },
  { value: 'private',  label: 'Private',  description: 'Visible to your team',           dot: '#0EA5E9' },
  { value: 'public',   label: 'Public',   description: 'Shareable externally',           dot: '#10B981' },
  { value: 'archived', label: 'Archived', description: 'Hidden from team',               dot: '#F59E0B' },
];

export interface StatusMenuProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onPick: (status: ContentStatus) => void;
}

export const StatusMenu: React.FC<StatusMenuProps> = ({ anchorEl, onClose, onPick }) => (
  <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onClose}>
    {OPTIONS.map((opt) => (
      <MenuItem
        key={opt.value}
        onClick={() => { onPick(opt.value); onClose(); }}
        sx={{ py: 1, gap: 1.25 }}
      >
        <Box sx={{ width: 8, height: 8, borderRadius: '50%', background: opt.dot, flexShrink: 0 }} />
        <ListItemText
          primary={<Typography variant="body2" sx={{ fontWeight: 700 }}>{opt.label}</Typography>}
          secondary={<Typography variant="caption" color="text.secondary">{opt.description}</Typography>}
        />
      </MenuItem>
    ))}
  </Menu>
);
